<template>
    <div class="thm-heading d-inline-block">
        <h3>{{$t('choose-from-recent-accounts','Choose from recent accounts')}}</h3>
    </div>
    <div class="recent-secWrap">
        <div class="recent-sec slct-bank-wrapper-sec" :class="{'show' : accountId == account.client_account_id}" v-for="(account, index) in userAccounts" :key="index">
            <div class="form-check" @click="selectUserAccount(account)">
                <div class="bank-slct-img">
                    <div class="check-box-inpt-box">
                        <input class="form-check-input flexRadioDefault-sec" type="radio" :id="'bank-info' + account.client_account_id" :checked="accountId == account.client_account_id">
                    </div>
                    <div class="bankAccount-icon">
                        <img loading="lazy" :src="account.icon" alt="bank icon">
                    </div>
                </div>
                <div class="slct-bank-details">
                    <label class="form-check-label" :for="'bank-info' + account.client_account_id">
                        <div class="recent-bank-sec">
                            <ul class="add-acc-details-wrapper">
                                <li>
                                    <div class="walletInfo__item-title" v-if="account.method_name">
                                        <span class="bank-title1">{{$t('bank-name','Bank Name')}}</span>
                                        <span class="dots-div">:</span>
                                        <span class="add-bank-title2">{{ account.method_name }}</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="walletInfo__item-title" v-if="account.account_number">
                                        <span class="bank-title1">{{$t('account-number','Account Number')}}</span>
                                        <span class="dots-div">:</span>
                                        <span class="add-bank-title2">{{ account.account_number }}</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="walletInfo__item-title" v-if="account.ifsc_code">
                                    <span class="bank-title1">{{$t('ifsc-code','IFSC Code')}}</span>
                                    <span class="dots-div">:</span>
                                    <span class="add-bank-title2">{{ account.ifsc_code }}</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="walletInfo__item-title" v-if="account.account_holder_name">
                                        <span class="bank-title1">{{$t('account-holder-name','Account Holder Name')}}</span>
                                        <span class="dots-div">:</span>
                                        <span class="add-bank-title2">{{ account.account_holder_name }}</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="walletInfo__item-title" v-if="account.phone_number"> 
                                        <span class="bank-title1">{{$t('phone-number','Phone Number')}}</span>
                                        <span class="dots-div">:</span>
                                        <span>{{ account.phone_number }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </label>
                </div>
            </div>
            <div class="menu-dots menu-delete-btn">
                <div class="btn-group dropstart">
                    <button type="button" class="border-0 bg-transparent dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <img src="@/assets/images/menu-dots.svg" alt="menu-dots">
                    </button>
                    <ul class="dropdown-menu">
                        <button class="border-0 bg-transparent" @click="handleRemoveAccount(account)">
                            <div class="remove-sec">
                                <div class="remove-icon">
                                    <img src="@/assets/images/remove-icon.svg" alt="remove-icon">
                                </div>
                                <div class="remove-con">
                                    <span>{{$t('remove-account','Remove account')}}</span>
                                </div>
                            </div>
                        </button>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="deposit total-amount mt-2" >
        <div class="deposit__title d-flex justify-content-between mt-1">
            <span style="align-self: center;">
                {{$t('withdraw-amount','Withdraw Amount')}}
            </span>
            <span class="grid-item p-1 avail-bal-spc">
            {{('available','Avail Bal')}}: 
                {{ withdrawlBalance }}
            </span>
        </div>
        <div class="deposit-amountInput">
            <input type="number" v-model="amount" @input=" amount = $helper.sanitizeNumber(+amount, +walletConfig?.withdrawal_range?.max || 99999999)" class="enter-amount-box" :placeholder="$t('enter-withdraw-amount','Enter Withdraw Amount')">
            <span class="error-messages-text" v-if="v$.amount.$error">{{$t('please-enter-amount','Please Enter Amount')}}</span>
            <!-- <div class="online-form-int">
                <label class="form-check-label gray-color">({{$t('min-amount','Min amount')}}:  {{ walletConfig?.withdrawal_range.min || 100  }})</label>
            </div> -->
            <!-- <span class="deposit-amountInput-currency">INR</span> -->
            <div class="deposit__title d-flex justify-content-end mt-0">
                <span class="min_max-title"> {{ $t('min', 'Min') }} 
                    {{ walletConfig?.withdrawal_range?.min }} | {{ $t('max', 'Max') }} {{ walletConfig?.withdrawal_range?.max }}
                </span>
            </div>
        </div>
        <div class="grid-container mt-2" v-if="walletConfig?.stake_button">
            <template v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes] : walletConfig?.stake_button)" :key="index">
                <button @click="setStakeValue(stake)" class="grid-item">+{{stake }}</button>
            </template>
        </div>
        <div class="proceed-btn depo_edit_save_btn">
             <button type="button" class="edit-btn"  @click="openEditStakeModal()">
                <span class="fa fa-edit"></span> {{$t('edit-stake', 'Edit Stake')}}
            </button>
            <button type="button"  @click="validateWithdrawAmount" class="submit-btn" :disabled="amount < walletConfig?.withdrawal_range?.min">
                {{ $t('submit','Submit') }}
            </button>
        </div>

    </div>

    <div class="deposit total-amount mt-2">
        <div class="withdraw-input-content">
            <div class="rules-button">
                <div class="rulesAccept">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="termCondition" id="consolidate">
                        <label class="form-check-label">
                            <span class="rulesAccept__text">{{$t('i-have-read-and-agree-with','I have read and agree with')}}
                                <a href="#payment-policy" data-bs-toggle="modal" class="rulesAccept__text-underline">{{$t('the-terms-of-payment-and-withdrawal-policy','the terms of payment and withdrawal policy.')}}</a>
                            </span>
                        </label>
                    </div>
                </div>
                <!-- <div class="proceed-btn">
                    <a href="javascript:void(0)" @click="withdrawWalletAmount"> Proceed </a>
                </div> -->
            </div>
        </div>
    </div>
    <!-- <ApprovalBeforeRemoving v-if="showModal" :selectedAccount="selectedAccount" @getPreviousBankDetails="getPreviousBankDetails"/> -->
    <Confirmation v-if="showModal"
        @confirm="confirmDelete"
        @cancel="$helper.closeModal('deleteConfirmationModal')"
    />
    <TwoFAModal
		v-if="show2FAModal"
		:loading="twoFaLoading"
		:showTimer="false"
		@close="show2FAModal = false"
		@verify="verifyTwoFa"
	/>
    <StakeModal :stakes="walletStake" v-if="showModal" @updateStakes="saveButtonClick"/>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import {withdrawAmountClickValidation} from '@template/utils'
import { check2FaStatus, verifyTwoFa, withdrawWalletAmount, removeAccount } from '@template/utils'
import Confirmation from '@/shared/components/confirmation/Confirmation.vue';
import StakeModal from '../components/StakeModal.vue';
import TwoFAModal from '@/modules/2FA/components/TwoFAModal.vue';

export default {
    name: 'PreviousAccount',
    setup() {
        return { v$: useVuelidate() }
    },
    props:['userAccounts', 'records','walletConfig'],
    emits:['getPreviousBankDetails'],
    components:{
        Confirmation,
        StakeModal,
        TwoFAModal
    },
    computed: {
        ...mapGetters(['userBonus', 'userTransactionStakes']),
        withdrawlBalance() {
            let { balance = 0, expl = 0 } = this.$auth?.user || {};
            let earnBonus = this.$auth.user.earnBonus || 0;
            return (parseFloat(balance) + parseFloat(expl || 0) - parseFloat(earnBonus)).toFixed(2);
        }
    },
    data(){
        return{
            accountId:this.userAccounts.length > 0 ? this.userAccounts[0].client_account_id : null,
            amount:null,
            termCondition:null,
            selectedAccount: null,
            showModal: false,
            walletStake:null,

            show2FAModal:false,
            twoFaLoading:false
        }
    },
    validations: {
        amount: { required}
    },
    watch: {
        userAccounts: {
            immediate: true,
            handler(newVal) {
                if (newVal.length > 0) {
                    this.accountId = newVal[0].client_account_id;
                }
            }
        }
    },
    mounted() {
        this.getWalletLimits()        
    },
    methods:{
        async verifyTwoFa(otp){
			this.twoFaLoading = true
            this.withdrawWalletAmount(otp)
            this.twoFaLoading = false
            this.show2FAModal = false
		},
		check2FaStatus(){
           const response = check2FaStatus();
            if(response?.is2faEnabled){
                this.show2FAModal = true
           }else{
                this.withdrawWalletAmount()
           }
        },
        openEditStakeModal() {
            this.showModal = true
            this.$helper.openModal('#singlestakeeditModal');
        },
        saveButtonClick(stakes) {
            this.walletStake = stakes;
        },
        
        getWalletLimits() {
            this.walletStake = this.walletConfig?.stake_button;
            if(!this.walletStake) { 
                this.initializeStake();
            } 
        },
        initializeStake(){
            if (!this.walletStake) {
                this.walletStake = {};
            }
            this.walletStake = {
                stake1 : 100,
                stake2 : 500,
                stake3 : 1000,
                stake4 : 2000,
            };
        },
        async validateWithdrawAmount(){
            this.v$.$touch();
            if (this.v$.$error) {
                return;
            }
            let isValid = await withdrawAmountClickValidation(this.amount, this.walletConfig, this.withdrawlBalance);
            if(isValid) 
            this.check2FaStatus()
        },
        async withdrawWalletAmount(otp = null) {
            this.termCondition = true;
            this.$store.dispatch('setGlobalLoader', true);
            let response = await withdrawWalletAmount(this.amount, this.accountId, otp);
            this.$store.dispatch('setGlobalLoader', false);
            if (!response?.error) {
                this.$router.push({ name: 'Home' });
            } else {
                this.termCondition = false;
            }
        },

        selectUserAccount(account){
            this.accountId = account.client_account_id
        },
        async handleRemoveAccount(account){
            this.showModal = true
            this.selectedAccount = account;
            this.$helper.openModal('#deleteConfirmationModal')
        },
        async confirmDelete() {
            this.$helper.closeModal('deleteConfirmationModal')
            await this.removeAccount();
        },
        async removeAccount(){
            let response = await removeAccount(this.selectedAccount.client_account_id)
            if(response) {
                this.getPreviousBankDetails();
            }
        },
        setStakeValue(stake) {
            this.amount += parseFloat(stake);
            if(this.amount > this.walletConfig?.withdrawal_range?.max){
                this.amount = this.walletConfig?.withdrawal_range?.max;
            }
        },
        getPreviousBankDetails(){
            this.$emit('getPreviousBankDetails')
        }
    }
}
</script>